import { Link } from 'react-router-dom';
import type { Project } from '@/types/content';
import { GalleryCard } from './GalleryCard';
import { FadeIn } from '@/components/motion/FadeIn';

interface ProjectRailProps {
  projects: Project[];
  heading?: string;
  cta?: { label: string; to: string };
}

/**
 * Editorial project rail on the homepage. Displays the first 3-4 projects
 * in a magazine-style asymmetric layout. Cards animate in via FadeIn.
 */
export function ProjectRail({ projects, heading = 'Selected work', cta }: ProjectRailProps) {
  return (
    <section className="project-rail section">
      <div className="container">
        <header className="project-rail__header">
          <FadeIn>
            <p className="eyebrow">Portfolio</p>
            <h2 className="project-rail__heading">{heading}</h2>
          </FadeIn>
        </header>
        <div className="project-rail__cards">
          {projects.slice(0, 4).map((p, i) => (
            <FadeIn key={p.slug} delay={i * 80}>
              <GalleryCard project={p} index={i} />
            </FadeIn>
          ))}
        </div>
        {cta ? (
          <FadeIn delay={250}>
            <div className="project-rail__cta">
              <Link to={cta.to} className="cta-ghost">{cta.label}</Link>
            </div>
          </FadeIn>
        ) : null}
      </div>
    </section>
  );
}
